// extracted by mini-css-extract-plugin
export default {"container":"NewList_container__UTidN","buttonPageSelect":"NewList_buttonPageSelect__i8oiV"};